import { Vertex, mirrorPoints } from "./points";

interface PathProps {
  vertices: Vertex[];
  mirror: boolean;
  onInsertHandle?: Function;
  insertMode?: boolean;
}

interface CommandValues {
  initialM: string;
  command: string;
  handleIndex: number;
}

export default function Path({
  vertices,
  mirror,
  onInsertHandle,
  insertMode = false,
}: PathProps) {
  if (!vertices.length) {
    return null;
  }

  vertices = mirror ? mirrorPoints(vertices) : vertices;

  let finishingSpline = false;
  let lastCommand: CommandValues;
  let textCommands: CommandValues[] = [];
  vertices.forEach((vertex, i) => {
    const lastIndex = i === 0 ? vertices.length - 1 : i - 1;
    const lastPoint = vertices[lastIndex];
    const { x, y } = vertex;

    if (vertex.type === "control") {
      finishingSpline = true;
      lastCommand = {
        initialM: `M ${lastPoint.x}, ${lastPoint.y}`,
        command: ` Q ${x}, ${y}`,
        handleIndex: -1, //dummy, changing it on the next iteration.
      };
    } else {
      if (finishingSpline) {
        lastCommand.handleIndex = i;
        lastCommand.command += ` ${x}, ${y}`;
        textCommands.push(lastCommand);
        finishingSpline = false;
      } else {
        textCommands.push({
          initialM: `M ${lastPoint.x}, ${lastPoint.y}`,
          command: ` L ${x}, ${y}`,
          handleIndex: i,
        });
      }
    }
  });

  //Non interactive mode. Create a single path.
  if (!onInsertHandle) {
    const commands = textCommands.map((command) => command.command);
    const commandsString = commands.join("\n");
    const path = `M ${vertices[0].x}, ${vertices[0].y}\n ${commandsString} Z`;
    return (
      <path
        className="svg-path"
        d={path}
        stroke="black"
        fill="black"
        strokeWidth="1.5"
        strokeOpacity="1"
        opacity="1"
        fillOpacity="0"
      />
    );
  }

  const paths = textCommands.map(
    ({ initialM, command, handleIndex }: CommandValues, i) => {
      const path = initialM + command;
      return (
        <g
          key={i}
          className="path"
          onClick={(e) => {
            if (insertMode && onInsertHandle) {
              e.stopPropagation(); //Prevent appending another.
              onInsertHandle(handleIndex, e);
            }
          }}
        >
          <path
            d={path}
            stroke="red"
            strokeWidth="12"
            strokeOpacity="0.0"
            opacity="1"
            fillOpacity="0"
          />

          <path
            d={path}
            stroke="LightSkyBlue"
            fill="blue"
            strokeWidth="1.5"
            strokeOpacity="1"
            opacity="1"
            fillOpacity="0"
          />
        </g>
      );
    }
  );

  return <g className="pattern-path">{paths}</g>;
}
